export type SportsTimeFilterType = 'all' | 'today' | 'tomorrow' | 'current-week' | 'next-week';

export const SPORTS_TIME_FILTER_IDS: readonly SportsTimeFilterType[] = [
    'today',
    'tomorrow',
    'current-week',
    'next-week',
] as const;

export const ALL_SPORTS_TIME_FILTER_IDS: readonly SportsTimeFilterType[] = [
    'all',
    'today',
    'tomorrow',
    'current-week',
    'next-week',
] as const;

const SPORTS_WITH_ALL_TIME_FILTER = new Set(['boxing', 'tennis', 'baseball', 'golf', 'mixedmartialarts']);

export const getTimeFilterIds = (sport: string): readonly SportsTimeFilterType[] => {
    if (SPORTS_WITH_ALL_TIME_FILTER.has(sport) === true) {
        return ALL_SPORTS_TIME_FILTER_IDS;
    }

    return SPORTS_TIME_FILTER_IDS;
};

export const isSportsTimeFilterType = (value: string, sport: string): value is SportsTimeFilterType => {
    return getTimeFilterIds(sport).includes(value as SportsTimeFilterType);
};
